export interface IErrorResponse {
    statusCode: number;
    error: any;
    errorCode: any;
    message: string;
    attemp?: number;
}
